import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { addNewTour } from '@/actions/add-new-tour';
import { fetchTourCateogry } from '@/actions/fetch-tour-category';

export const useCategory = (draftId?: string) => {
  const queryClient = useQueryClient();
  const [selectedCategory, setSelectedCategory] = useState<number>(0);
  const toggleSelect = (id: number) => setSelectedCategory((prev) => (prev !== id ? id : 0));

  const initialDataQuery = useQuery({
    queryKey: ['tour-category', draftId],
    queryFn: async () => {
      if (!draftId) return { categoryId: 0 };
      const data = await fetchTourCateogry(Number(draftId));
      setSelectedCategory(data.categoryId);
      return data;
    },
    refetchOnWindowFocus: false,
  });

  const { mutate, status } = useMutation({
    mutationKey: ['tour-category', selectedCategory],
    mutationFn: ({ selectedCategory, tourId }: { selectedCategory: number; tourId?: number }) =>
      addNewTour(selectedCategory, tourId),
    onSuccess: (draftId) => {
      queryClient.invalidateQueries({
        queryKey: ['tour-category', draftId],
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return {
    selectedCategory,
    toggleSelect,
    updateDraft: mutate,
    updateStatus: status,
  };
};
